import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { TASK_TYPE_FILTER_OPTIONS } from '../../../helpers/taskTypes'

const state = {
  type: TASK_TYPE_FILTER_OPTIONS.slice(),
  qtys: [
    {id: '0', name: 'None'},
    {id: '1', name: '1'},
    {id: '2', name: '2'},
    {id: '3', name: '3'},
    {id: '4', name: '4'},
    {id: '5', name: '5'},
    {id: '6', name: '6'},
    {id: '7', name: '7'},
    {id: '8', name: '8'},
    {id: '9', name: '9'},
    {id: '10', name: '10'},
    {id: '11', name: '11'},
    {id: '12', name: '12'},
    {id: '13', name: '13'},
    {id: '14', name: '14'},
    {id: '15', name: '15'}
  ],
  time_hours: [
    {id: 0, name: '0 Hr'},
    {id: 1, name: '1 Hr'},
    {id: 2, name: '2 Hr'},
    {id: 3, name: '3 Hr'},
    {id: 4, name: '4 Hr'},
    {id: 5, name: '5 Hr'},
    {id: 6, name: '6 Hr'},
    {id: 7, name: '7 Hr'},
    {id: 8, name: '8 Hr'},
    {id: 9, name: '9 Hr'},
    {id: 10, name: '10 Hr'},
    {id: 11, name: '11 Hr'},
    {id: 12, name: '12 Hr'},
    {id: 13, name: '13 Hr'},
    {id: 14, name: '14 Hr'},
    {id: 15, name: '15 Hr'},
    {id: 16, name: '16 Hr'},
    {id: 17, name: '17 Hr'},
    {id: 18, name: '18 Hr'},
    {id: 19, name: '19 Hr'},
    {id: 20, name: '20 Hr'},
    {id: 21, name: '21 Hr'},
    {id: 22, name: '22 Hr'},
    {id: 23, name: '23 Hr'}
  ],
  time_minutes: [
    {id: 0, name: '0 Min'},
    {id: 0.5, name: '0.5 Min'},
    {id: 1, name: '1 Min'},
    {id: 2, name: '2 Min'},
    {id: 3, name: '3 Min'},
    {id: 4, name: '4 Min'},
    {id: 5, name: '5 Min'},
    {id: 6, name: '6 Min'},
    {id: 7, name: '7 Min'},
    {id: 8, name: '8 Min'},
    {id: 9, name: '9 Min'},
    {id: 10, name: '10 Min'},
    {id: 11, name: '11 Min'},
    {id: 12, name: '12 Min'},
    {id: 13, name: '13 Min'},
    {id: 14, name: '14 Min'},
    {id: 15, name: '15 Min'},
    {id: 16, name: '16 Min'},
    {id: 17, name: '17 Min'},
    {id: 18, name: '18 Min'},
    {id: 19, name: '19 Min'},
    {id: 20, name: '20 Min'},
    {id: 21, name: '21 Min'},
    {id: 22, name: '22 Min'},
    {id: 23, name: '23 Min'},
    {id: 24, name: '24 Min'},
    {id: 25, name: '25 Min'},
    {id: 26, name: '26 Min'},
    {id: 27, name: '27 Min'},
    {id: 28, name: '28 Min'},
    {id: 29, name: '29 Min'},
    {id: 30, name: '30 Min'},
    {id: 31, name: '31 Min'},
    {id: 32, name: '32 Min'},
    {id: 33, name: '33 Min'},
    {id: 34, name: '34 Min'},
    {id: 35, name: '35 Min'},
    {id: 36, name: '36 Min'},
    {id: 37, name: '37 Min'},
    {id: 38, name: '38 Min'},
    {id: 39, name: '39 Min'},
    {id: 40, name: '40 Min'},
    {id: 41, name: '41 Min'},
    {id: 42, name: '42 Min'},
    {id: 43, name: '43 Min'},
    {id: 44, name: '44 Min'},
    {id: 45, name: '45 Min'},
    {id: 46, name: '46 Min'},
    {id: 47, name: '47 Min'},
    {id: 48, name: '48 Min'},
    {id: 49, name: '49 Min'},
    {id: 50, name: '50 Min'},
    {id: 51, name: '51 Min'},
    {id: 52, name: '52 Min'},
    {id: 53, name: '53 Min'},
    {id: 54, name: '54 Min'},
    {id: 55, name: '55 Min'},
    {id: 56, name: '56 Min'},
    {id: 57, name: '57 Min'},
    {id: 58, name: '58 Min'},
    {id: 59, name: '59 Min'}
  ],
  multipliers: [
      { id: 0.1, name: "0.1x" },
      { id: 0.2, name: "0.2x" },
      { id: 0.3, name: "0.3x" },
      { id: 0.4, name: "0.4x" },
      { id: 0.5, name: "0.5x" },
      { id: 0.6, name: "0.6x" },
      { id: 0.7, name: "0.7x" },
      { id: 0.8, name: "0.8x" },
      { id: 0.9, name: "0.9x" },
      { id: 1.0, name: "1.0x" },
      { id: 1.1, name: "1.1x" },
      { id: 1.2, name: "1.2x" },
      { id: 1.3, name: "1.3x" },
      { id: 1.4, name: "1.4x" },
      { id: 1.5, name: "1.5x" },
      { id: 1.6, name: "1.6x" },
      { id: 1.7, name: "1.7x" },
      { id: 1.8, name: "1.8x" },
      { id: 1.9, name: "1.9x" },
      { id: 2.0, name: "2.0x" },
      { id: 2.1, name: "2.1x" },
      { id: 2.2, name: "2.2x" },
      { id: 2.3, name: "2.3x" },
      { id: 2.4, name: "2.4x" },
      { id: 2.5, name: "2.5x" },
      { id: 2.6, name: "2.6x" },
      { id: 2.7, name: "2.7x" },
      { id: 2.8, name: "2.8x" },
      { id: 2.9, name: "2.9x" },
      { id: 3.0, name: "3.0x" },
      { id: 3.1, name: "3.1x" },
      { id: 3.2, name: "3.2x" },
      { id: 3.3, name: "3.3x" },
      { id: 3.4, name: "3.4x" },
      { id: 3.5, name: "3.5x" },
      { id: 3.6, name: "3.6x" },
      { id: 3.7, name: "3.7x" },
      { id: 3.8, name: "3.8x" },
      { id: 3.9, name: "3.9x" },
      { id: 4.0, name: "4.0x" },
      { id: 4.1, name: "4.1x" },
      { id: 4.2, name: "4.2x" },
      { id: 4.3, name: "4.3x" },
      { id: 4.4, name: "4.4x" },
      { id: 4.5, name: "4.5x" },
      { id: 4.6, name: "4.6x" },
      { id: 4.7, name: "4.7x" },
      { id: 4.8, name: "4.8x" },
      { id: 4.9, name: "4.9x" },
      { id: 5.0, name: "5.0x" }
  ]
}

export default {
  state,
  getters,
  mutations,
  actions
}
